<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.79622 6.01953C6.98531 5.9806 7.18162 5.99744 7.36133 6.06771H7.36198L13.362 8.40104L13.3633 8.40169C13.5321 8.46767 13.6793 8.57817 13.7897 8.7207L13.8346 8.78385L13.875 8.85026C13.962 9.00803 14.005 9.18683 13.9987 9.36784C13.9915 9.57488 13.9199 9.77471 13.7943 9.93945C13.6687 10.1041 13.4952 10.226 13.2975 10.2878H13.2962L11 11H10.9993V11.0007L10.2878 13.2962V13.2975C10.226 13.4952 10.1041 13.6687 9.93945 13.7943C9.77471 13.9199 9.57489 13.9915 9.36784 13.9987C9.16086 14.0059 8.95691 13.9484 8.78385 13.8346C8.61075 13.7208 8.4771 13.5562 8.40169 13.3633L8.40104 13.362L6.06771 7.36198V7.36133C5.99744 7.18162 5.9806 6.98531 6.01953 6.79622C6.05891 6.60502 6.15363 6.4297 6.29167 6.29167L6.34505 6.24154C6.47369 6.13051 6.629 6.05397 6.79622 6.01953ZM9.29688 11.9876L9.72591 10.6061L9.7832 10.4544C9.84936 10.307 9.94173 10.1722 10.0566 10.0573C10.2099 9.90402 10.3984 9.79063 10.6055 9.72656L11.9876 9.29687L7.58464 7.58463L9.29688 11.9876ZM12 6V2C12 1.82319 11.9297 1.65367 11.8047 1.52865C11.6797 1.40362 11.5101 1.33333 11.3333 1.33333H2C1.82319 1.33333 1.65367 1.40362 1.52865 1.52865C1.40362 1.65367 1.33333 1.82319 1.33333 2V11.3333C1.33333 11.5101 1.40362 11.6797 1.52865 11.8047C1.65367 11.9297 1.82319 12 2 12H6C6.36819 12 6.66667 12.2985 6.66667 12.6667C6.66667 13.0349 6.36819 13.3333 6 13.3333H2C1.46957 13.3333 0.96101 13.1225 0.585938 12.7474C0.210865 12.3723 0 11.8638 0 11.3333V2C0 1.46957 0.210865 0.96101 0.585938 0.585937C0.96101 0.210865 1.46957 0 2 0H11.3333C11.8638 0 12.3723 0.210865 12.7474 0.585937C13.1225 0.96101 13.3333 1.46957 13.3333 2V6C13.3333 6.36819 13.0349 6.66667 12.6667 6.66667C12.2985 6.66667 12 6.36819 12 6Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'GuideIcon',
  props: {
    size: {
      type: [Number, String],
      default: 11
    },
    fill: {
      type: String,
      default: '#62676D'
    }
  }
};
</script>
